import React from 'react';

interface Update {
  updateId: string;
  updatedAt: string;
  updatedBy?: {
    _id: string;
    displayName: string;
    email: string;
  };
  previousValue: number;
  newValue: number;
  notes?: string;
  statusChange?: string;
}

interface GoalUpdateHistoryProps {
  updates: Update[];
  unit: string;
  className?: string;
}

const GoalUpdateHistory: React.FC<GoalUpdateHistoryProps> = ({ updates, unit, className = '' }) => {
  if (!updates || updates.length === 0) return null;

  return (
    <div className={`mt-3 border-t pt-3 ${className}`}>
      <details className="text-sm">
        <summary className="cursor-pointer text-blue-600 hover:text-blue-800">
          View Update History ({updates.length} update{updates.length > 1 ? 's' : ''})
        </summary>
        <div className="mt-2 space-y-2">
          {[...updates]
            .sort((a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime())
            .map((update) => (
              <div key={update.updateId} className="pl-4 border-l-2 border-gray-200">
                <div className="font-medium">
                  {update.previousValue} → {update.newValue} {unit}
                </div>
                <div className="text-xs text-gray-500">
                  {new Date(update.updatedAt).toLocaleString()} by{' '}
                  {update.updatedBy?.displayName || 'Unknown'}
                </div>
                {update.statusChange && (
                  <div className="text-xs text-blue-600">{update.statusChange}</div>
                )}
                {update.notes && (
                  <div className="text-xs text-gray-600 mt-1">{update.notes}</div>
                )}
              </div>
            ))}
        </div>
      </details>
    </div>
  );
};

export default GoalUpdateHistory;

